import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../container/layout";
import { isMobile } from "react-device-detect";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import clsx from "clsx";
import EventHeader from "../../container/event/header";
import {
  Text,
  Date,
  Email,
  ListSearch,
  Check,
  FieldNumber,
  File,
  TextArea,
  Image,
} from "../../component/form";
import { loadFields, save } from "./action";
import moment from "moment";
import { validateEmail, validateTaxid, validatePhone } from "../../utils";
import DGAlert from "../../component/alert";
import { initPage } from "../home/action";

const useStyles = makeStyles((theme) => ({
  bg: {
    backgroundImage: "url('/photo/bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center bottom",
    [theme.breakpoints.up("xs")]: {
      padding: 16,
    },
    [theme.breakpoints.down("xs")]: {
      backgroundImage: "none",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  main: {
    border: "1px solid #EFEFEF",
    boxSizing: "border-box",
    maxWidth: 953,
    margin: "0 auto",
    marginTop: 16,
    padding: "32px 0 64px 0",
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
    [theme.breakpoints.up("xs")]: {
      marginTop: 32,
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
    },
  },
  textField: {
    width: "501px !important",
    margin: 32,
    color: "black",
  },
  banner: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: 58,
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: 113.51,
    },
    width: "100%",
    maxWidth: 953,
    maxHeight: 250,
    objectFit: "cover",
    margin: "0 auto",
    color: "#000000",
    textAlign: "center",
    "& img": {
      width: "100%",
      maxWidth: 953,
      maxHeight: 250,
      objectFit: "cover",
    },
  },
  required: {
    color: "#c92028",
  },
  checkBox: {
    [theme.breakpoints.up("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: "49%",
    },
  },
  inputFile: {
    borderBottom: "1px solid #dddddd",
    margin: "16px 8px 32px 8px",
    paddingBottom: 16,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      "& .fileContainer": {
        alignItems: "left !important",
      },
      "& .fileContainer .uploadPictureContainer": {
        marginLeft: 0,
      },
    },
  },
  button: {
    marginTop: 8,
    padding: 0,
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      maxWidth: "273px",
      height: "56px",
    },
    [theme.breakpoints.up("md")]: {
      width: "411px",
      height: "70px",
    },
  },
  errorText: {
    margin: "16px 0 16px 0",
    color: "#f44336",
  },
  inputForm: {
    marginTop: 32,
    [theme.breakpoints.up("md")]: {
      padding: "32px 86px 32px 86px",
    },
  },
}));

const Register = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [state, setState] = React.useState({
    form: [],
    open: true,
    agree: false,
    alert: false,
    error: {},
    errorText: {},
    snack: false,
    snackMsg: "",
    event: { banner_inside_mobile: [], banner_inside_desktop: [] },
  });

  const handleRegister = () => {
    const fields = {};
    const require = {};
    const errorText = {};
    state.form.forEach((f) => {
      setState({ ...state, open: true });
      if (f.type === "date" && !!f.value) {
        fields[f.name] = moment(f.value).format("YYYY-MM-DD");
      }
      if (
        ["text", "list", "number", "textarea", "file", "image"].includes(
          f.type
        ) &&
        !!f.value
      ) {
        fields[f.name] = f.value;

        if (f.name === "idCard") {
          if (!validateTaxid(f.value)) {
            require[f.name] = true;
            errorText[f.name] = `เลขบัตรประชาชนยังไม่ถูกต้อง`;
          }
        }

        if (f.name === "tel") {
          if (!validatePhone(f.value)) {
            require[f.name] = true;
            errorText[f.name] = `เบอร์โทรศัพท์ยังไม่ถูกต้อง`;
          }
        }
      }

      if (f.type === "email") {
        fields[f.name] = f.value;
        if (!validateEmail(f.value)) {
          require[f.name] = true;
          errorText[f.name] = `${f.placeholder} ไม่ถูกต้อง`;
        }
      }

      if (f.type === "checkbox") {
        const listChecked = f.list.filter((l) => l.checked);
        fields[f.name] = JSON.stringify(listChecked);
        if (listChecked.length === 0 && f.required) {
          require[f.name] = true;
          errorText[f.name] = `กรุณาระบุ ${f.placeholder}`;
        }
      }

      if (f.required) {
        if (!!!fields[f.name]) {
          require[f.name] = true;
          errorText[f.name] = `กรุณาระบุ ${f.placeholder}`;
        }
      }

      if (/^question.*/g.test(f.name)) {
        fields[f.name] = JSON.stringify({
          where: f.select_table === "other" ? "othermaster" : "master",
          label: f.question_label !== "" ? f.question_label : f.label,
          type: f.type,
          value: fields[f.name],
        });
      }
    });
    fields.form_id = state.event.form_id;

    if (Object.keys(require).length > 0) {
      setState({
        ...state,
        open: false,
        alert: true,
        error: require,
        errorText,
      });
    } else {
      save(state, setState, fields, navigate);
    }
  };

  const classes = useStyles();

  const handleChangeText = (v, k) => {
    const value = v.target.value;
    const obj = [...state.form];
    obj[k].value = value;
    const require = { ...state.error };

    switch (obj[k].name) {
      case "idCard":
        if (value.length > 13) {
          obj[k].value = value.substr(0, 13);
        }
        if (validateTaxid(obj[k].value)) {
          require[obj[k].name] = false;
        } else {
          require[obj[k].name] = true;
        }
        break;
      case "email":
        if (validateEmail(value)) {
          require[obj[k].name] = false;
        } else {
          require[obj[k].name] = true;
        }
        break;
      case "tel":
        if (validatePhone(value)) {
          require[obj[k].name] = false;
        } else {
          require[obj[k].name] = true;
        }
        if (value.length > 10) {
          obj[k].value = value.substr(0, 10);
        }
        break;
      case "firstname":
      case "lastname":
        if (value.length > 10) {
          obj[k].value = value.substr(0, 50);
        }
        break;
      default:
        if (!!v.target.value) {
          require[obj[k].name] = false;
        }
        break;
    }
    setState({ ...state, form: obj, error: require });
  };

  const handleChangeDate = (date, k) => {
    const obj = [...state.form];
    obj[k].value = date;
    const require = { ...state.error };
    if (!!date) {
      require[obj[k].name] = false;
    }

    setState({ ...state, form: obj, error: require });
  };

  const handleFile = (f, k) => {
    const obj = [...state.form];
    obj[k].value = f[0];
    const require = { ...state.error };
    if (f.length > 0) {
      require[obj[k].name] = false;
    }
    setState({ ...state, form: obj, error: require });
  };

  const handleUpload = (f, k) => {
    const obj = [...state.form];
    obj[k].value = f[0];
    const require = { ...state.error };
    if (f.length > 0) {
      require[obj[k].name] = false;
    }

    setState({ ...state, form: obj, error: require });
  };

  const handleChangeList = (v, k) => {
    const obj = [...state.form];
    if (v === null) {
      obj[k].value = "";
    } else {
      obj[k].value = v;
      const require = { ...state.error };
      require[obj[k].name] = false;
    }

    setState({ ...state, form: obj, error: require });
  };

  const handleChangeCheck = (v, k) => {
    const obj = [...state.form];
    let lists = [];
    if (state.form[k].select_table === "other") {
      lists = state.form[k].list.map((l) => ({
        ...l,
        checked:
          (+l.otherId === +v.target.name && v.target.checked) ||
          (+l.otherId !== +v.target.name && l.checked),
      }));
    } else {
      lists = state.form[k].list.map((l) => ({
        ...l,
        checked:
          (+l.masterid === +v.target.name && v.target.checked) ||
          (+l.masterid !== +v.target.name && l.checked),
      }));
    }

    obj[k].list = lists;

    const require = { ...state.error };
    if (lists.length > 0) {
      require[obj[k].name] = false;
    }

    setState({ ...state, form: obj, error: require });
  };

  const handleChangeMore = (v, k, name) => {
    if (name === "interesting") {
      const obj = [...state.form];

      const lists = state.form[k].list.map((l) => ({
        ...l,
        checked:
          +l.masterid === 999999 ? (v === "" ? false : true) : !!l.checked,
        mastername: +l.masterid === 999999 ? v : l.mastername,
      }));

      obj[k].list = lists;
      const require = { ...state.error };
      if (lists.length > 0) {
        require[obj[k].name] = false;
      }
      setState({ ...state, form: obj, error: require });
    }
  };

  const alertConfirm = () => {
    setState({ ...state, alert: false });
  };

  const handleSnackClose = () => {
    setState({ ...state, snack: false });
  };

  useEffect(() => {
    loadFields(state, setState, id);

    if (!!window.location.search) {
      window.localStorage.setItem("utm", window.location.search);
      window.localStorage.setItem(
        "utm_ex",
        moment().add("30", "days").format()
      );
    }

    const utm_ex = window.localStorage.getItem("utm_ex");
    if (!!utm_ex) {
      if (moment(utm_ex).diff(moment(), "days") < 0) {
        window.localStorage.removeItem("utm");
        window.localStorage.removeItem("utm_ex");
      }
    }
  }, []);

  return (
    <div className={classes.bg}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={state.snack}
        onClose={handleSnackClose}
        message={state.snackMsg}
      />
      <Backdrop className={classes.backdrop} open={state.open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DGAlert
        title={"กรุณากรอกข้อมูล"}
        description={Object.keys(state.errorText).map((e, k) => (
          <div key={k}>{state.errorText[e]}</div>
        ))}
        open={state.alert}
        onConfirm={alertConfirm}
        labelConfirm="ปิด"
      />
      <div className={classes.banner}>
        <img
          src={
            isMobile
              ? `${process.env.REACT_APP_API_URL}/images/${
                  !!state.event.banner_inside_mobile
                    ? state.event.banner_inside_mobile[0]
                    : ""
                }`
              : `${process.env.REACT_APP_API_URL}/images/${
                  !!state.event.banner_inside_desktop
                    ? state.event.banner_inside_desktop[0]
                    : ""
                }`
          }
          alt=""
          width="100%"
        />
      </div>
      <Layout>
        <div className={classes.main}>
          <EventHeader
            title={state.event.assetName}
            description={state.event.des2}
            name="ลงทะเบียนกิจกรรม"
          />

          <form className={classes.inputForm} noValidate autoComplete="off">
            {state.form.map((f, k) => (
              <div key={k}>
                {f.type === "text" && (
                  <Text
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(v) => handleChangeText(v, k)}
                  />
                )}
                {f.type === "textarea" && (
                  <TextArea
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(v) => handleChangeText(v, k)}
                  />
                )}

                {f.type === "number" && (
                  <FieldNumber
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(v) => handleChangeText(v, k)}
                  />
                )}
                {f.type === "email" && (
                  <Email
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(v) => handleChangeText(v, k)}
                  />
                )}
                {f.type === "date" && (
                  <Date
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(d) => handleChangeDate(d, k)}
                  />
                )}
                {f.type === "list" && (
                  <ListSearch
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(e, v) => handleChangeList(v, k)}
                  />
                )}
                {f.type === "checkbox" && (
                  <Check
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    onChange={(v) => handleChangeCheck(v, k)}
                    onChangeMore={(v) => handleChangeMore(v, k, f.name)}
                  />
                )}
                {f.type === "file" && (
                  <File
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    handleFile={(v) => handleFile(v, k)}
                  />
                )}
                {f.type === "image" && (
                  <Image
                    error={state.error[f.name]}
                    classes={classes}
                    obj={f}
                    handleUpload={(v) => handleUpload(v, k)}
                  />
                )}
              </div>
            ))}
          </form>

          <div style={{ marginTop: 32, textAlign: "center", padding: 8 }}>
            <FormControlLabel
              onChange={(v) => setState({ ...state, agree: v.target.checked })}
              control={
                <Checkbox
                  color="primary"
                  name="policy"
                  style={{ marginTop: -32 }}
                />
              }
              label={
                <div
                  style={{
                    maxWidth: 319,
                    textAlign: "left",
                    lineHeight: "32px",
                    fontSize: 18,
                    fontWeight: 501,
                  }}
                >
                  ยอมรับ{" "}
                  <Link
                    target="_blank"
                    style={{ textDecoration: "underline" }}
                    href="https://career.apthai.com/TermAndCondition.aspx"
                  >
                    เงื่อนไขข้อตกลงการใช้บริการ
                  </Link>{" "}
                  และ{" "}
                  <Link
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                    href="https://career.apthai.com/PrivacyPolicy.aspx"
                  >
                    นโยบายความเป็นส่วนตัว
                  </Link>
                </div>
              }
            />
          </div>

          <div style={{ marginTop: 16, textAlign: "center" }}>
            <Button
              variant="contained"
              disabled={!state.agree}
              color="primary"
              className={classes.button}
              onClick={handleRegister}
            >
              ลงทะเบียน
            </Button>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Register;
